import useRepo from '@/nebula/repo';
import useSavedViewRepo from '@/composables/saved-views/saved-view-repo';
import { computed } from 'vue';
import { findViews } from '@/lib/saved-view/saved-view';
import { savedView as savedViewConfig } from 'shared/api/query/configs.json';

export default function useViewsRepo({ application, space = null, planning = null, user = null, gridPageTile = null }) {
  const repo = useSavedViewRepo();

  const { entityList: allViews } = useRepo(savedViewConfig.model);
  const applicationViews = computed(() => findViews({
    views: allViews.value,
    application,
    space,
    planning,
    user,
    gridPageTile,
  }));

  const createViews = (views, isDefaultView) => repo.createMultiple(views, {}, { isDefaultView });

  const deleteView = (view) => repo.deleteSingle(view.uid);

  return {
    loadingCreateView: repo.createLoading,
    createViews,

    loadingUpdateView: repo.updateLoading,
    updateView: repo.updateSingle,

    loadingUpdateMetaData: repo.updateLoading,

    loadingDeleteView: repo.deleteLoading,
    deleteView,

    views: applicationViews,
  };
}
